import React, { useEffect, useState } from "react";

import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

import { IMenuList } from "./interface";
import { Container, Header, Body, ButtonNavigate } from "./styles";

export const MenuList: React.FC<IMenuList> = ({
  title,
  list,
  open,
  currentLocale,
  handleOpen,
  navigate,
}) => {
  const [show, setShow] = useState(title.toLowerCase() === open || false);

  useEffect(() => {
    if (!show && open === title.toLowerCase()) {
      setShow(true);
    }

    if (show && !(open === title.toLowerCase())) {
      setShow(false);
    }
  }, []);

  const handleShow = () => {
    setShow(!show);
    handleOpen(title.toLocaleLowerCase());
  };

  return (
    <Container>
      <Header onClick={handleShow}>
        <h1>{title}</h1>
        {show ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
      </Header>
      {show && (
        <Body>
          {list.map(
            ({ menuTitle, locale, read, id, datacy }) =>
              read && (
                <ButtonNavigate
                  key={menuTitle + id}
                  id={id}
                  selected={locale === currentLocale}
                  onClick={() => navigate(locale)}
                  data-cy={datacy}
                >
                  {menuTitle}
                </ButtonNavigate>
              ),
          )}
        </Body>
      )}
    </Container>
  );
};
